/**
 * Created by calhosh on 7/13/2017.
 */
import React from 'react';
import EllipseControl from '../EllipsesControl/EllipsesControl';
import MotifCheckbox from '@ey/motif-react-wrapper/Checkbox';
import StyledCheckBox from './StyledCheckBox';

export default function CheckBox(props) {
	const {
		label,
		name,
		title,
		value,
		checked,
		disabled,
		dataAutoID,
		ellipse,
		inline,
		noOfLines,
		styleName,
		className,
		customElement,
		statusLabel,
		hidetitletip,
		id,
		onChange,
		indeterminate,
		ariaLabel,
		customLabelWidth
	} = props;
	return (
		<StyledCheckBox customLabelWidth={customLabelWidth} className={styleName ? styleName : ''}>
			<MotifCheckbox
				id={id}
				name={name}
				inline={inline}
				value={value}
				title={title}
				onChange={onChange}
				checked={checked}
				disabled={disabled}
				className={className}
				data-autoid={dataAutoID}
				indeterminate={indeterminate}
				aria-label={ariaLabel}
			>
				{customElement && customElement}
				{ellipse ? (
					<EllipseControl
						ellipsisClass="checkboxLabel"
						content={label}
						id={name}
						tooltip={label}
						displayId={props.displayId}
						noOfLines={noOfLines}
					/>
				) : (
					<span htmlFor={id} title={hidetitletip ? '' : title} className="checkboxLabel-statusLabel">
						{label}
						{statusLabel && <span className="statusLabel">{statusLabel}</span>}
					</span>
				)}
			</MotifCheckbox>
		</StyledCheckBox>
	);
}

CheckBox.defaultProps = {
	customLabelWidth: '75%'
};
